export const WHATSAPP_NUMBER = "34628769627";
export const WHATSAPP_MESSAGE = "Hola, me gustaría información sobre los servicios de Lavandería Ozono";

export const ADSENSE_CLIENT = "ca-pub-8068576538593045";

export const GOOGLE_PLACE = {
  name: "Lavandería Autoservicio+Industrial Zaragoza | Clean Master",
  rating: 4.7,
  shareUrl: "https://share.google/sIopFXCJu664KWpsr",
  mapsUrl: "https://www.google.com/maps?cid=9292236937905589102",
  reviewUrl:
    "https://www.google.com/search?q=Lavander%C3%ADa+Clean+Master+Zaragoza&ludocid=9292236937905589102#lrd=0xd5915e6e964cf9b:0x80f4a8433ca04b6e,3",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1655041448985-f6666cba2d6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB3YXNoaW5nJTIwbWFjaGluZSUyMGxhdW5kcnklMjByb29tfGVufDB8fHx8MTc4NjkyMDI5Mnww&ixlib=rb-4.1.0&q=85",
  folded: "https://images.unsplash.com/photo-1517816743773-6e0fd518b4a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGZvbGRlZCUyMGxhdW5kcnklMjBtaW5pbWFsJTIwd2hpdGUlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NjkyMDI5Mnww&ixlib=rb-4.1.0&q=85",
  bedding: "https://images.unsplash.com/photo-1601276174812-63280a55656e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGZyZXNoJTIwc2hlZXRzJTIwYmVkJTIwbW9ybmluZyUyMHN1bmxpZ2h0fGVufDB8fHx8MTc4NjkyMDI5Mnww&ixlib=rb-4.1.0&q=85",
  domicilio: "/img/domicilio.jpg",
  laundromat: "/img/local/interior.jpg",
};

export const LOCAL_PHOTOS = [
  { src: "/img/local/fachada.jpg", alt: "Fachada de Lavandería Ozono en la calle María Zayas Sotomayor, Actur", caption: "Nuestro local en el Actur", wide: true },
  { src: "/img/local/maquinas.jpg", alt: "Lavadoras y secadoras industriales del autoservicio", caption: "Lavadoras de 12 y 20 kg y secadoras de 19 kg", wideRow: true },
  { src: "/img/local/interior.jpg", alt: "Interior del local con la central de pago y la mesa para doblar la ropa", caption: "Central de pago y mesa para doblar" },
  { src: "/img/local/vending.jpg", alt: "Máquinas de café y snacks de la zona vending", caption: "Café y snacks mientras esperas" },
];
